import { i18nMark } from 'lingui-react';

const messages = {
  noResultsTitle: i18nMark('No matches for'),
  noResultsNoMatch: i18nMark('Try broadening your search criteria.'),
  noResultsWrongQuery: i18nMark('Enter at least 3 characters for your search.'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/SearchResultsPanel/messages.js